import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  researchPendingData: null,
  finalData: "",
  apiCompleted: false,
  query: "",
  selectedCategory: null,
  resultToApi: null,
  researchItemsClick: "",
  queryLoader: false,
  showSlowResponsePopup: false,

  selectedid: null,
  saveName: null,
  userquery: null,
  saveCreatedDate: null,
  refinedUserQuery: "",
  selectedDataLimit: null,
  trendcore: null,
  trenrendrefine: "",
  selectedData: {
    Tier_1: [],
    Tier_2: {},
    Tier_3: {},
  },
  abortController: null,
  errorState: false,
  toastMessage: null,
  userEmailId: "",
  useCasedata: null,
  userCodeVerification: false,
  contactSales: null,
};

const sceneSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setResearchPendingData: (state, action) => {
      state.researchPendingData = action.payload;
    },
    setFinalData: (state, { payload }) => {
      state.finalData = payload;
    },
    setApiCompleted: (state, { payload }) => {
      state.apiCompleted = payload;
    },
    setQuery: (state, { payload }) => {
      state.query = payload;
    },
    setSelectedCategory: (state, { payload }) => {
      state.selectedCategory = payload;
    },
    setResultToApi: (state, { payload }) => {
      state.resultToApi = payload;
    },
    setResearchItemsClick: (state, { payload }) => {
      state.researchItemsClick = payload;
    },
    setQueryLoader: (state, { payload }) => {
      state.queryLoader = payload;
    },
    setShowSlowResponsePopup: (state, { payload }) => {
      state.showSlowResponsePopup = payload;
    },
    setSeletedId: (state, { payload }) => {
      state.selectedid = payload;
    },
    setSaveCreatedDate: (state, { payload }) => {
      state.saveCreatedDate = payload;
    },
    setSaveName: (state, { payload }) => {
      state.saveName = payload;
    },
    setUserQuery: (state, { payload }) => {
      state.userquery = payload;
    },
    setRefinedUserQuery: (state, { payload }) => {
      state.refinedUserQuery = payload;
    },
    setTrendcore: (state, { payload }) => {
      state.trendcore = payload;
    },
    setTrendrefine: (state, { payload }) => {
      state.trenrendrefine = payload;
    },
    setSelectedDataLimit: (state, { payload }) => {
      state.selectedDataLimit = payload;
    },
    setSelectedData: (state, { payload }) => {
      state.selectedData = payload;
    },
    setAbortController: (state, { payload }) => {
      state.abortController = payload;
    },
    setErrorState: (state, { payload }) => {
      state.errorState = payload;
    },
    invokeToast: (state, { payload }) => {
      state.toastMessage = payload;
    },
    setUserEmailId: (state, { payload }) => {
      state.userEmailId = payload;
    },
    setUseCasedata: (state, { payload }) => {
      state.useCasedata = payload;
    },
    setUserCodeVerification: (state, { payload }) => {
      state.userCodeVerification = payload;
    },
    setContactSales: (state, { payload }) => {
      state.contactSales = payload;
    },
    extraReducers: (builder) => {},
  },
});

export const {
  setResearchPendingData,
  setFinalData,
  setApiCompleted,
  setQuery,
  setSelectedCategory,
  setResultToApi,
  setResearchItemsClick,
  setQueryLoader,
  setShowSlowResponsePopup,
  setSeletedId,
  setSaveCreatedDate,
  setSaveName,
  setUserQuery,
  setRefinedUserQuery,
  setTrendcore,
  setTrendrefine,
  setSelectedDataLimit,
  setSelectedData,
  setAbortController,
  setErrorState,
  invokeToast,
  setUserEmailId,
  setUseCasedata,
  setUserCodeVerification,
  setContactSales,
} = sceneSlice.actions;
export default sceneSlice.reducer;
